import React from 'react';
import { Button, Table, Header, Segment, Loader, Grid } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import SearchTableData from '../../util/SearchTableData';
import { ExportReactCSV } from '../../util/ExportCSV';
import PaginationFront from '../../util/PaginationFront';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p><FormattedMessage id="professorInputGrades.NoUpcomingExamsMessage" /></p>;

export default class ProfessorUpcomingExams extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            professorId: '',
            orgUnitId: '',

            loading: true,
            error: false,

            results: []


        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getExams = this.getExams.bind(this);
        this.downloadICSFile = this.downloadICSFile.bind(this);
    }

    componentDidMount() {
        this.getExams();
    }

    getExams(professorId, organizationalUnitId) {
        // professorId, orgUnitId
        axios.get(`professor/upcoming-exams/${window.$locale}/`)
            .then(res => {
                const data = res.data.map(el => ({
                    ...el,
                    date: moment(el.gradedActivityDate).format('D. M. YYYY. - HH:mm')
                }));
                this.setState({ data, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch upcoming exams');
                this.setState({ error: true });
            });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
    }

    downloadICSFile(exam) {
        const startTime = moment(exam.gradedActivityDate).format('YYYYMMDDTHHmmss');
        const endTime = moment(exam.gradedActivityDate).add(2, 'hours').format('YYYYMMDDTHHmmss'); // Assuming 2-hour duration

        const eventDetails = `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Your App//NONSGML v1.0//EN
BEGIN:VEVENT
UID:${new Date().toISOString()}
DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').split('.')[0]}
DTSTART:${startTime}
DTEND:${endTime}
SUMMARY:${exam.courseImplementationName} - ${exam.gradedActivityName}
DESCRIPTION:${exam.courseComment || 'No description'}
LOCATION:${exam.classroom}
END:VEVENT
END:VCALENDAR
        `;

        const blob = new Blob([eventDetails], { type: 'text/calendar' });
        const url = URL.createObjectURL(blob);

        // Trigger file download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${exam.courseImplementationName}-exam.ics`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        const { data } = this.state;

        return (
            <div>
                {console.log('window.location.pathname', window.location.pathname)}
                { (window.location.pathname === '/predstoje%C4%87i-ispiti' || window.location.pathname === '/upcoming-exams') &&
                    <Header as="h1">
                        <FormattedMessage id="professorInputGrades.upcomingExams" />
                    </Header>
                }
                <Grid centered>
                    <Grid.Row stretched>
                        <Grid.Column>
                            {this.props.noSegment ?
                                this.state.loading ?
                                    <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                                    : <div>
                                        {
                                            this.getDataToRender().length ?
                                                <Table celled selectable compact>
                                                    <Table.Header>
                                                        <Table.Row>
                                                            <Table.HeaderCell colSpan={13} >
                                                                <Grid stackable>
                                                                    <Grid.Column>
                                                                        <SearchTableData profMozilla data={this.getDataToRender()} getResults={this.getResults} filterItem={['courseImplementationName', 'gradedActivityName']} />
                                                                    </Grid.Column>
                                                                </Grid>
                                                            </Table.HeaderCell>
                                                        </Table.Row>
                                                        <Table.Row>
                                                            <Table.HeaderCell colSpan="1">
                                                                <FormattedMessage id="common.ordinal" />
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell colSpan="3">
                                                                <FormattedMessage id="common.courseName" />
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell colSpan="2" >
                                                                <FormattedMessage id="professorInputGrades.examType" />
                                                                <div style={{
                                                                    fontSize: '0.85em',
                                                                    color: '#999'
                                                                }}>
                                                                    <FormattedMessage id="professorInputGrades.methodName" />
                                                                </div>
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell colSpan="2">
                                                                <FormattedMessage id="professorInputGrades.examDateDate" />
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell colSpan="2">
                                                                <FormattedMessage id="common.classroom" />
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell colSpan="3" />
                                                        </Table.Row>
                                                    </Table.Header>
                                                    <Table.Body> {this.getDataToRender().map((el, index) =>
                                                        (<Table.Row key={el.gradedActivityId}>
                                                            <Table.Cell colSpan="1" verticalAlign="middle">
                                                                {index + 1}.
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" colSpan="3">
                                                                <Grid centered className="stackable">
                                                                    <Grid.Row verticalAlign="middle">
                                                                        <Grid.Column width="10">
                                                                            {el.courseImplementationName}
                                                                        </Grid.Column>
                                                                        <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                                            <span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>
                                                                        </Grid.Column>
                                                                    </Grid.Row>
                                                                </Grid>
                                                            </Table.Cell>
                                                            <Table.Cell colSpan="2" verticalAlign="middle">
                                                                {el.gradedActivityName}
                                                                <div style={{
                                                                    fontSize: '0.85em',
                                                                    color: '#999'
                                                                }}>
                                                                    {el.gradingMethodName ? el.gradingMethodName : ''}
                                                                </div>
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" colSpan="2">
                                                                {el.date}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" colSpan="2">
                                                                {el.classroom}
                                                            </Table.Cell>
                                                            <Table.Cell verticalAlign="middle" textAlign="center" colSpan="3">
                                                                <FormattedMessage id="route.registeredStudents">
                                                                    {(msg) => (<Link to={{
                                                                        pathname: msg,
                                                                        state: { exam: el }
                                                                    }}
                                                                    >  <Button color="blue" basic="true"><FormattedMessage id="professorInputGrades.registeredStudents" /></Button>

                                                                    </Link>)}
                                                                </FormattedMessage>
                                                                {/* <FormattedMessage id="route.registeredStudents"> */}
                                                                {/*     {(msg) => (<Button */}
                                                                {/*         color="blue" */}
                                                                {/*         onClick={() => this.downloadICSFile(el)} */}
                                                                {/*     > */}
                                                                {/*         <FormattedMessage id="professorInputGrades.addToCalendar" /> */}
                                                                {/*     </Button>)}</FormattedMessage> */}
                                                            </Table.Cell>
                                                        </Table.Row>))}
                                                    </Table.Body>
                                                </Table>

                                                : <NoDataMessage />}
                                    </div>

                                :
                                <Segment.Group raised >
                                        <Segment>
                                        <Header as="h3">
                                                <FormattedMessage id="professorInputGrades.upcomingExamsList" />
                                            </Header>
                                    </Segment>

                                        <Segment>
                                        {this.getDataToRender().length ?
                                                <Table celled selectable compact>
                                                <Table.Header>
                                                        <Table.Row>
                                                        <Table.HeaderCell colSpan={12} >
                                                                <Grid stackable>
                                                                <Grid.Column>
                                                                        <SearchTableData profMozilla data={this.getDataToRender()} getResults={this.getResults} filterItem={['courseImplementationName', 'gradedActivityName']} />
                                                                    </Grid.Column>
                                                            </Grid>
                                                            </Table.HeaderCell>
                                                    </Table.Row>
                                                        <Table.Row>
                                                        <Table.HeaderCell colSpan="1">
                                                                <FormattedMessage id="common.ordinal" />
                                                            </Table.HeaderCell>
                                                        <Table.HeaderCell colSpan="3">
                                                                <FormattedMessage id="common.courseName" />
                                                            </Table.HeaderCell>
                                                        <Table.HeaderCell colSpan="2">
                                                                <FormattedMessage id="professorInputGrades.examType" />
                                                            {/*<FormattedMessage id="professorInputGrades.examType" />*/}
                                                            <div style={{
                                                                fontSize: '0.85em',
                                                                color: '#999'
                                                            }}>
                                                                <FormattedMessage id="professorInputGrades.methodName" />
                                                            </div>
                                                            </Table.HeaderCell>
                                                        <Table.HeaderCell colSpan="2">
                                                                <FormattedMessage id="professorInputGrades.examDateDate" />
                                                            </Table.HeaderCell>
                                                        <Table.HeaderCell colSpan="2">
                                                                <FormattedMessage id="common.classroom" />
                                                            </Table.HeaderCell>
                                                        <Table.HeaderCell colSpan="2" />
                                                    </Table.Row>
                                                    </Table.Header>
                                                <Table.Body> {this.getDataToRender().map((el, index) =>
                                                    (<Table.Row key={el.gradedActivityId}>
                                                        <Table.Cell colSpan="1" verticalAlign="middle">
                                                            {index + 1}.
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle" colSpan="3">
                                                            <Grid columns={1} centered className="stackable">
                                                                <Grid.Row verticalAlign="middle">
                                                                    <Grid.Column width="10">
                                                                        {el.courseImplementationName}
                                                                    </Grid.Column>
                                                                    <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                                        <span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>
                                                                    </Grid.Column>
                                                                </Grid.Row>
                                                            </Grid>
                                                        </Table.Cell>
                                                        <Table.Cell colSpan="2" verticalAlign="middle">
                                                            {el.gradedActivityName}
                                                            <div style={{
                                                                fontSize: '0.85em',
                                                                color: '#999'
                                                            }}>
                                                                {el.gradingMethodName ? el.gradingMethodName : ''}
                                                            </div>
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle" colSpan="2">
                                                            {el.date}
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle" colSpan="2">
                                                            {el.classroom}
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle" textAlign="center" colSpan="2">
                                                            <FormattedMessage id="route.registeredStudents">
                                                                {(msg) => (<Link to={{
                                                                    pathname: msg,
                                                                    state: { exam: el }
                                                                }}
                                                                >  <Button color="blue" basic="true"><FormattedMessage id="professorInputGrades.registeredStudents" /></Button>

                                                                </Link>)}</FormattedMessage>
                                                        </Table.Cell>
                                                    </Table.Row>))}
                                                    </Table.Body>
                                            </Table>

                                            : <NoDataMessage />

                                        }

                                    </Segment>
                                        <ToastContainer hideProgressBar />
                                    </Segment.Group>
                            }

                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorUpcomingExams/ProfessorUpcomingExams.js